/**
 * 0과 1 사이의 값으로 제한된 스케일 값을 안전하게 관리하는 VO
 */
export class ScaleVO {
  readonly value: number;

  private constructor(value: number) {
    this.value = value;
  }

  static one(): ScaleVO {
    return ScaleVO.create(1);
  }

  static create(value: number): ScaleVO {
    const clamped = Math.max(0, Math.min(1, value));
    return new ScaleVO(clamped);
  }

  static fromPercentage(percentage: number): ScaleVO {
    return ScaleVO.create(percentage / 100);
  }

  equals(other: ScaleVO, tolerance = 0.001): boolean {
    return Math.abs(this.value - other.value) < tolerance;
  }
}
